import { TaskDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedList } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { Task } from '@skinsoft/types';
import { toFeatured$ } from '../../serializer/featured';

@Component({
    components: {
        sEntityFeaturedList: EntityFeaturedList,
    },
    props: ['targetRouteName'],
    template: require('./task-featured-list.html'),
})
export class TaskFeaturedList extends ReactiveVue {
    public $taskDataStore: TaskDataStore;
    public featuredStates = TaskDataStore.featuredStates;
    public sortFields = TaskDataStore.sortFields;
    public serializer = (task: Task) => toFeatured$(task, '') // '' just for avoiding problem with this at initialization

    mounted() {
        // passing directlt this.$i18n.locale to the toFeatured inside the serializer arrow function
        // was not working as the "this" was not pointing to the TaskFeaturedList class
        const locale = this.getAppLocale()
        this.serializer = (task: Task) => toFeatured$(task, locale)
    }
}
